import { Injectable } from '@angular/core';
import { Store, State } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { Loadable } from '../common/loadable';
import {
    LoadProductionPriceListsAction, LoadProductionPriceListAction, ChangeProductionPriceListFilterExpressionAction,
    ChangeProductionPriceListPageAction, ChangeProductionPriceListSortExpressionAction, ChangeProductionPriceListTotalCountAction,
    ChangeConditionsShowOnlyValidConditionsAction
} from './actions';
import { AppState } from "src/state/app.state";
import { ProductionPriceListApiService } from '../../api/services/production-price-list-api.service';
import { ProductionPriceList, ProductionPriceListForm } from './state-models/production-price-list';
import { Paging } from 'src/state/common/state-models/paging';
import { ProductionPriceListState } from './state'
import { ProductionPriceCondition } from './state-models/production-price-condition';


@Injectable({
    providedIn: "root",
})

export class ProductionPriceListStateService {
    constructor(
        private appStore: Store<AppState>,
        private apiService: ProductionPriceListApiService,
        private appState: State<AppState>) { }

    @Loadable()
    async loadPriceLists(): Promise<void> {
        const priceLists = await this.apiService.getAllPriceLists();
        this.appStore.dispatch(new LoadProductionPriceListsAction(priceLists));
    }
    getProductionPriceLists(): Observable<ProductionPriceList[]> {
        return this.appStore
            .select(state => state.productionPriceList.formProductionPriceList).pipe(map(item => _.values(item)));
    }

    @Loadable()
    async loadProductionPriceList(
        id: number | null,
        paging: Paging,
        sortExpression: string,
        filterExpression: string,
        showOnlyValidConditions: boolean = true,
    ) {
        const payload = {
            id: id ?? null,
            paging: {
                page: paging.page,
                offset: paging.offset
            },
            order: sortExpression,
            filter: filterExpression,
            showOnlyValidConditions
        };
        const response = await this.apiService.getProductionPriceConditions(payload);
        const list: ProductionPriceCondition[] = response?.list ?? [];
        this.appStore.dispatch(new LoadProductionPriceListAction(list));
        this.appStore.dispatch(new ChangeProductionPriceListTotalCountAction(response.totalCount));
    }

    getList(): Observable<ProductionPriceCondition[]> {
        return this.appStore
            .select(state => state.productionPriceList.productionPriceList).pipe(map(item => _.values(item)));
    }

    async refetchList(id: number): Promise<void> {
        const state = <ProductionPriceListState>this.appState.getValue().productionPriceList
        
        await this.loadProductionPriceList(id, state.productionPriceListPaging,
            state.productionPriceListFilterExpression, state.productionPriceListSortExpression, state.showOnlyValidConditions);

    }

    showOnlyValidConditions(showOVCondtions: boolean) {
            this.appStore.dispatch(new ChangeConditionsShowOnlyValidConditionsAction(showOVCondtions));
        }
    
        getshowOnlyValidConditions(): Observable<boolean> {
            return this.appStore.select(state => state.productionPriceList.showOnlyValidConditions);
        }

    getSortingExpression(type: string): Observable<string> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListSortExpression);
    }

    getProductionPriceListSortExpression(): Observable<string> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListSortExpression
        );
    }

    getFilterExpression(type: string): Observable<string> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListFilterExpression);
    }

    getProductionPriceListFilterExpression(): Observable<string> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListFilterExpression
        );
    }

    sortProductionPriceList(sortExpression: string) {
        this.appStore.dispatch(
            new ChangeProductionPriceListSortExpressionAction(
                sortExpression
            )
        );
    }

    filterProductionPriceList(filterExpression: string) {
        this.appStore.dispatch(
            new ChangeProductionPriceListFilterExpressionAction(
                filterExpression
            )
        );
    }

    getPaging(): Observable<Paging> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListPaging);
    }

    goToPage(page: number) {
        this.appStore.dispatch(new ChangeProductionPriceListPageAction(page));
    }

    getTotalCount(): Observable<number> {
        return this.appStore.select(
            (state) =>
                state.productionPriceList.productionPriceListTotalCount);
    }

    clearProductionPriceListFilterAndSorting() {
        this.sortProductionPriceList(null);
        this.filterProductionPriceList(null);
    }




    async exportSelectedPriceList(id:number,fileName:string){
        await this.apiService.exportSelectedProductionPriceList(id,fileName);
    }
}
